<template>
  <v-autocomplete
      v-model="value"
      :items="values"
      item-text="name"
      item-value="id"
      :label="label"
      return-object
      hide-details
  />
</template>

<script>
import VueTypes from "vue-types";
import {SmartOfferBundleShopType} from "@/modules/redactor/models/smart-offer/bundle-shop/SmartOfferBundleShopType";
export default {
  name: "r-smart-offer-bundle-shop-type",
  props: {
    model: VueTypes.instanceOf(SmartOfferBundleShopType),
    label: VueTypes.string.def("Kind:")
  },
  computed: {
    value: {
      get: function () {
        return this.model;
      },
      set: function (value) {
        this.$emit("update:model", value);
      }
    },
    values() {
      return SmartOfferBundleShopType.getValues();
    }
  }
}
</script>